import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { UseQueryOverrideOptions } from '../common';

export type AppointmentMetricsResponse = {
  last_updated: string;
  summary_data: {
    monthly: {
      title: string;
      trend: number;
      value: number;
    }[];
    weekly: {
      title: string;
      trend: number;
      value: number;
    }[];
  };
};

export const useGetAppointmentMetrics = (
  params: {} = {},
  options: UseQueryOverrideOptions<AppointmentMetricsResponse> = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['appointmentMetrics', params],
    queryFn: () => api.get('/get_appointments_summary').then((res) => res.data),
  });
};
